import { render, staticRenderFns } from "./profile-settings.vue?vue&type=template&id=0c3be865&"
import script from "./profile-settings.vue?vue&type=script&lang=js&"
export * from "./profile-settings.vue?vue&type=script&lang=js&"
import style0 from "./profile-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports